import React from "react";
import EnterRecoveryCode from '../../views/login/enterRecoveryCode'

export default function EnterRecoveryCodePage() {
    return <EnterRecoveryCode />
}
